var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoga02(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 152,
    viewBox: "0 0 152 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.9445 63.3333C54.2876 72.1797 58.928 80.4643 57.8563 90.6565C56.143 106.95 36.3858 113.083 23.7514 120.589C15.4739 125.507 18.5687 139.333 28.7269 139.333C41.043 139.333 52.0351 138.35 63.1471 133.127L84.937 119.718C87.9618 118.296 91.7782 118.902 95 120.333",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9445 63.3333C54.2876 72.1797 58.928 80.4643 57.8563 90.6565C56.143 106.95 36.3858 113.083 23.7514 120.589C15.4739 125.507 18.5687 139.333 28.7269 139.333C41.043 139.333 52.0351 138.35 63.1471 133.127L84.937 119.718C87.9618 118.296 91.7782 118.902 95 120.333",
    stroke: "url(#paint0_linear_16725_949)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M101.4 63.3333C96.9646 72.1797 92.226 80.4643 93.3204 90.6565C95.0703 106.95 115.246 113.083 128.148 120.589C136.601 125.507 133.44 139.333 123.067 139.333C110.49 139.333 99.2649 138.35 87.9174 133.127L65.6659 119.718C63.0685 118.522 59.8992 118.761 57 119.718",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M101.4 63.3333C96.9646 72.1797 92.226 80.4643 93.3204 90.6565C95.0703 106.95 115.246 113.083 128.148 120.589C136.601 125.507 133.44 139.333 123.067 139.333C110.49 139.333 99.2649 138.35 87.9174 133.127L65.6659 119.718C63.0685 118.522 59.8992 118.761 57 119.718",
    stroke: "url(#paint1_linear_16725_949)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3335 25.3334C63.3335 32.329 69.0044 38.0001 76.0002 38.0001C82.996 38.0001 88.6668 32.329 88.6668 25.3334C88.6668 18.3378 82.996 12.6667 76.0002 12.6667C69.0044 12.6667 63.3335 18.3378 63.3335 25.3334Z",
    stroke: "white",
    strokeWidth: 4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3335 25.3334C63.3335 32.329 69.0044 38.0001 76.0002 38.0001C82.996 38.0001 88.6668 32.329 88.6668 25.3334C88.6668 18.3378 82.996 12.6667 76.0002 12.6667C69.0044 12.6667 63.3335 18.3378 63.3335 25.3334Z",
    stroke: "url(#paint2_linear_16725_949)",
    strokeWidth: 4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19 101.333C34.4904 101.333 41.4433 84.2011 43.6579 72.3844C44.236 69.3 45.1722 66.2246 47.2229 63.8489C54.1912 55.7761 64.4987 50.6667 76 50.6667C87.5013 50.6667 97.8088 55.7761 104.777 63.8489C106.827 66.2246 107.764 69.3 108.342 72.3844C110.557 84.2011 117.509 101.333 133 101.333",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19 101.333C34.4904 101.333 41.4433 84.2011 43.6579 72.3844C44.236 69.3 45.1722 66.2246 47.2229 63.8489C54.1912 55.7761 64.4987 50.6667 76 50.6667C87.5013 50.6667 97.8088 55.7761 104.777 63.8489C106.827 66.2246 107.764 69.3 108.342 72.3844C110.557 84.2011 117.509 101.333 133 101.333",
    stroke: "url(#paint3_linear_16725_949)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16725_949",
    x1: 19,
    y1: 63.3333,
    x2: 109.319,
    y2: 89.0556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_16725_949",
    x1: 57,
    y1: 63.3333,
    x2: 147.319,
    y2: 89.0555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_16725_949",
    x1: 63.3335,
    y1: 12.6667,
    x2: 93.4398,
    y2: 21.2409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_16725_949",
    x1: 19,
    y1: 50.6667,
    x2: 122.832,
    y2: 117.201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoga02);
export default __webpack_public_path__ + "static/media/yoga-02.5e10caff892a5b4c1ee1a9999d7fe3af.svg";
export { ForwardRef as ReactComponent };